import { IconButton } from "@material-ui/core";
import { ArrowLeft, ArrowRight } from "@material-ui/icons";
import Cookies from "js-cookie";
import React, { useEffect, useRef, useState } from "react";
import { useLocation } from "react-router-dom";
import config from "../../../config/apiConfig";
import StoryCard from "../StoryCard/StoryCard";

type Props = {
    currentFilter: any;
    hasTimeline: boolean;
    appliedScores: any;
    currCount: number;
    canLoadMore: number;
    setCurrCount: (v: number) => any;
    setCanLoadMore: (v: boolean) => any;
    handleScrapbook: () => any;
};

function useQuery() {
    return new URLSearchParams(useLocation().search);
}

const ViewedStories: React.FC<Props> = (props) => {
    const {
        appliedScores,
        canLoadMore,
        currCount,
        currentFilter,
        hasTimeline,
        setCanLoadMore,
        setCurrCount,
        handleScrapbook,
    } = props;

    const article_tag = useQuery().get("article_tag");
    const entity = useQuery().get("entity");
    const person_entity = useQuery().get("person_entity");

    const scrollRef = useRef<HTMLDivElement>(null);

    const [storyList, setStoryList] = useState<any[]>([]);
    const [isLoading, setIsLoading] = useState(true);

    function handleShowMore(e: any) {
        e.preventDefault();
        setCurrCount(currCount + 1);
    }

    useEffect(() => {
        const formData = new FormData();
        const filterJson: { [key: string]: any } = {
            genre: currentFilter.genre.toString(),
            subgenre: currentFilter.sub_genre.toString(),
            language: currentFilter.language.toString(),
            country: currentFilter.country.toString(),
            state: currentFilter.state.toString(),
            city: currentFilter.city.toString(),
            protagonist: currentFilter.protagonist.toString(),
            emotion: currentFilter.emotion.toString(),
            sentiment: currentFilter.sentiment.toString(),
            has_timeline: hasTimeline,
            sustenance: appliedScores.sustenance,
            complexity: appliedScores.complexity,
            virality: appliedScores.virality,
            relevance: appliedScores.relevance,
        };
        if (article_tag) filterJson.article_tag = article_tag;
        if (entity) filterJson.entity = entity;
        if (person_entity) filterJson.person_entity = person_entity;

        formData.append("filters", JSON.stringify(filterJson));
        formData.append("session-token", Cookies.get("token") || "");
        formData.append("token", config.token);
        const requestOptions = {
            method: "POST",
            body: formData,
        };
        setIsLoading(true);
        fetch(
            config.BASE_URL +
                "/v1/get/stories_viewed?" +
                "climit=" +
                20 +
                "&page=" +
                currCount,
            requestOptions
        )
            .then((response) => response.json())
            .then((resp) => {
                if (resp.data.length < 20) {
                    setCanLoadMore(false);
                }
                if (currCount === 1) {
                    setStoryList(resp.data);
                } else {
                    setStoryList([...storyList, ...resp.data]);
                }
                setIsLoading(false);
            });
    }, [currentFilter, currCount, appliedScores, hasTimeline]);

    const scrollLeft = () => {
        if (!!scrollRef.current) scrollRef.current.scrollLeft -= 303;
    };

    const scrollRight = () => {
        if (!!scrollRef.current) scrollRef.current.scrollLeft += 303;
    };

    return (
        <React.Fragment>
            {storyList.length != 0 && (
                <div className="similar__container">
                    <div
                        style={{
                            margin: "0 26px",
                            borderBottom: "solid 1px rgba(112, 112, 112, 0.2)",
                        }}
                    >
                        <h4
                            style={{
                                fontSize: "20px",
                                marginBottom: "20px !important",
                                padding: "0 0 20px 0",
                            }}
                        >
                            Continue Reading
                        </h4>
                    </div>
                    <div
                        style={{
                            display: "flex",
                            alignItems: "center",
                            width: "calc(100% + 100px)",
                            marginLeft: -50
                        }}
                    >
                        <IconButton onClick={scrollLeft}>
                            <ArrowLeft fontSize="large" />
                        </IconButton>
                        <div
                            ref={scrollRef}
                            className="horiz__list"
                            style={{ flex: 1, marginInline: 16 }}
                        >
                            {storyList.map((story, index) => {
                                return (
                                    <div
                                        key={index}
                                        onClick={(e) => {
                                            e.preventDefault();
                                            const win = window.open(
                                                `/writer/story/${story.id}`,
                                                "_blank"
                                            );
                                            win?.focus();
                                        }}
                                        className="story__title story__title__small"
                                    >
                                        <StoryCard
                                            index={index}
                                            isRead={story.isViewed}
                                            isAdded={story.isInScrapebook}
                                            onScrapChange={handleScrapbook}
                                            image={story.images[0]?.link}
                                            score={story.story_score}
                                            id={story.id}
                                            title={story.title}
                                            isLiked={story.isLiked}
                                            fb_comments={
                                                story
                                                    .social_media_scores_details
                                                    ?.fb_comments
                                            }
                                            fb_shares={
                                                story
                                                    .social_media_scores_details
                                                    .fb_shares
                                            }
                                            fb_reactions={
                                                story
                                                    .social_media_scores_details
                                                    ?.fb_reactions
                                            }
                                        />
                                    </div>
                                );
                            })}
                            {!isLoading && canLoadMore && (
                                <div
                                    className="story__title story__title__small"
                                    style={{
                                        textAlign: "center",
                                        paddingTop: "100px",
                                    }}
                                >
                                    <button
                                        onClick={handleShowMore}
                                        className="borderless__btn"
                                        style={{ margin: "auto" }}
                                    >
                                        Show More
                                    </button>
                                </div>
                            )}
                        </div>
                        <IconButton onClick={scrollRight}>
                            <ArrowRight fontSize="large" />
                        </IconButton>
                    </div>
                    <div
                        style={{
                            margin: "0 26px",
                            borderBottom: "solid 1px rgba(112, 112, 112, 0.2)",
                        }}
                    ></div>
                </div>
            )}
        </React.Fragment>
    );
};

export default ViewedStories;
